export const ACTOR_TYPES = [
  "character",
  "monster"
];

/* -------------------------------------------- */

export const PROPERTIES = [
  "activeEffect.deleted",
  "activeEffect.disabled",
  "actor.inCombat",
  "actor.itemCreated",
  "actor.itemDeleted",
  "actor.name",
  "actor.system.aac.mod",
  "actor.system.ac.mod",
  "actor.system.config.ignoreBonusDamage",
  "actor.system.config.movementAuto",
  "actor.system.details.alignment",
  "actor.system.details.class",
  "actor.system.details.level",
  "actor.system.details.title",
  "actor.system.xp.bonus",
  "actor.system.xp.next",
  "actor.system.xp.share",
  "actor.system.xp.value",
  "actor.system.encumbrance.max",
  "actor.system.encumbrance.value",
  "actor.system.exploration.ft",
  "actor.system.exploration.ld",
  "actor.system.exploration.od",
  "actor.system.exploration.sd",
  "actor.system.hp.hd",
  "actor.system.hp.max",
  "actor.system.hp.value",
  "actor.system.initiative.value",
  "actor.system.initiative.mod",
  "actor.system.languages.value",
  "actor.system.movement.base",
  "actor.system.retainer.enabled",
  "actor.system.retainer.loyalty",
  "actor.system.retainer.wage",
  "actor.system.saves.breath.value",
  "actor.system.saves.death.value",
  "actor.system.saves.paralysis.value",
  "actor.system.saves.spell.value",
  "actor.system.saves.wand.value",
  "actor.system.scores.cha.bonus",
  "actor.system.scores.cha.value",
  "actor.system.scores.con.bonus",
  "actor.system.scores.con.value",
  "actor.system.scores.dex.bonus",
  "actor.system.scores.dex.value",
  "actor.system.scores.int.bonus",
  "actor.system.scores.int.value",
  "actor.system.scores.str.bonus",
  "actor.system.scores.str.value",
  "actor.system.scores.wis.bonus",
  "actor.system.scores.wis.value",
  "actor.system.spells.enabled",
  "actor.system.spells.1.used",
  "actor.system.spells.1.max",
  "actor.system.spells.2.used",
  "actor.system.spells.2.max",
  "actor.system.spells.3.used",
  "actor.system.spells.3.max",
  "actor.system.spells.4.used",
  "actor.system.spells.4.max",
  "actor.system.spells.5.used",
  "actor.system.spells.5.max",
  "actor.system.spells.6.used",
  "actor.system.spells.6.max",
  "actor.system.thac0.mod.melee",
  "actor.system.thac0.mod.missile",
  "item.name",
  "item.system.aac.value",
  "item.system.ac.value",
  "item.system.blindroll",
  "item.system.bonus",
  "item.system.cast",
  "item.system.class",
  "item.system.cost",
  "item.system.damage",
  "item.system.duration",
  "item.system.equipped",
  "item.system.lvl",
  "item.system.melee",
  "item.system.memorized",
  "item.system.missile",
  "item.system.quantity.value",
  "item.system.quantity.max",
  "item.system.range",
  "item.system.range.short",
  "item.system.range.medium",
  "item.system.range.long",
  "item.system.roll",
  "item.system.save",
  "item.system.slow",
  "item.system.tags",
  "item.system.treasure",
  "item.system.type",
  "item.system.weight",
  "token.disposition",
  "token.elevation",
  "token.name",
  "token.rotation",
  "token.sight.angle",
  "token.sight.attenuation",
  "token.sight.brightness",
  "token.sight.color",
  "token.sight.contrast",
  "token.sight.enabled",
  "token.sight.range",
  "token.sight.saturation",
  "token.sight.visionMode"
];

/* -------------------------------------------- */

export const DERIVED_PROPERTIES = [
];
